import { render } from "./VisitorCreateGatepass.vue?vue&type=template&id=3701264b&scoped=true"
import script from "./VisitorCreateGatepass.vue?vue&type=script&lang=js"
export * from "./VisitorCreateGatepass.vue?vue&type=script&lang=js"

import "./VisitorCreateGatepass.vue?vue&type=style&index=0&id=3701264b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3701264b"]])

export default __exports__